import React from 'react';
import { withRouter } from 'react-router-dom';
import { CookiesProvider, withCookies } from 'react-cookie';
import { Button, ButtonSizes, ButtonStyles, Badge, TextInput, IconButtonStyles } from '@silverfort/sf-components';
import { Icon, Icons } from '@silverfort/sf-components';
import { validateAdminConsolePass } from '@silverfort-nodelibs/common/utils/common';
import { httpGet, httpPost } from '../utils';
import CloudResourcesLogin from './CloudResourcesLogin';
class Login extends React.Component {
    constructor(props) {
        super(props);

        const { cookies } = this.props;

        this.state = {
            username: '',
            password: '',
            domain: cookies.get('sf-user-domain') || '',
            loading: true,
            loginInProgress: false,
            loginFailed: false,
            domainPrefix: false,
            showDomain: true,
            deleteDomainCookie: false,
            ssoEnabled: false,
            ssoText: 'Sign in with SSO',
            ssoServerPath: '/sso/saml',
            loginMode: 'login',
            cloudResourcesEnabled: false,
            cloudResourceLoginInProgress: false,
            redirectUrl: '/',
            oldPassword: '',
            newPassword: '',
            confirmPassword: ''
        };

        this.state.domainPrefix = this.state.domain.includes('\\');
    }

    componentDidMount() {
        httpGet('/login/options')
            .then((response) => {
                const responseData = response.data;
                const state = {};
                if (responseData.cloudResourcesEnabled && this.props.location.search.includes('cloudResourceLogin')) {
                    state.loginMode = 'cloudResourceLogin';
                    state.cloudResourceLoginInProgress = true;
                }
                if (responseData.loginError) {
                    state.loginFailed = true;
                }

                this.setState({
                    ssoEnabled: responseData.ssoEnabled,
                    ssoText: responseData.ssoText,
                    ssoServerPath: responseData.ssoServerPath,
                    cloudResourcesEnabled: responseData.cloudResourcesEnabled,
                    ...state
                });
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    }

    saveDomainCookie = () => {
        let domain = '';
        let splitUsername = this.state.username.split('@');
        if (splitUsername.length > 1 && splitUsername[1].length > 1) {
            domain = '@' + splitUsername[1];
        } else {
            splitUsername = this.state.username.split('\\');
            if (splitUsername.length > 1 && splitUsername[0].length > 1) {
                domain = splitUsername[0] + '\\';
            }
        }

        const { cookies } = this.props;
        if (domain) {
            cookies.set('sf-user-domain', domain, { path: '/', maxAge: 15552000 });
        } else if (this.state.deleteDomainCookie) {
            cookies.remove('sf-user-domain');
        }
    };

    clearDomainHandler = () => {
        this.setState({ showDomain: false, deleteDomainCookie: true });
    };

    usernameChangedHandler = (username) => {
        const showDomain = !this.state.deleteDomainCookie && !username.includes('@') && !username.includes('\\');
        this.setState({ username: username, showDomain: showDomain });
    };

    changePasswordHandler = () => {
        const validation = validateAdminConsolePass(
            this.state.oldPassword,
            this.state.newPassword,
            'Admin console password'
        );

        if (!validation.results) {
            this.setState({ changePasswordFailedMsg: validation.error });
        } else if (!this.state.newPassword || !this.state.confirmPassword) {
            this.setState({ changePasswordFailedMsg: 'Please enter new password and confirm it' });
        } else if (this.state.newPassword !== this.state.confirmPassword) {
            this.setState({ changePasswordFailedMsg: 'New password do not match confirmation password' });
        } else {
            this.loginHandler(true);
        }
    };

    loginHandler = (isPasswordChange) => {
        this.setState({ loginFailed: false, loginInProgress: true });

        let username = this.state.username;
        if (!this.deleteDomainCookie && this.state.showDomain) {
            if (this.state.domain.startsWith('@')) {
                username = username + this.state.domain;
            } else if (this.state.domain.endsWith('\\')) {
                username = this.state.domain + username;
            }
        }

        httpPost('/login', {
            username: username,
            password: isPasswordChange ? this.state.oldPassword : this.state.password,
            newPassword: isPasswordChange ? this.state.newPassword : undefined
        })
            .then((response) => {
                if (response.data && response.data.Result) {
                    this.saveDomainCookie();
                }

                if (response.data?.forcePasswordChange) {
                    this.setState({ loginMode: 'changePassword', loginInProgress: false });
                } else {
                    const redirectUrl = response.data?.RedirectTo ?? '/';
                    if (this.state.cloudResourcesEnabled && response.data?.hasCloudPermissions) {
                        this.setState({ redirectUrl, cloudResourceLoginInProgress: true });
                    } else {
                        window.location = redirectUrl;
                    }
                }
            })
            .catch((error) => {
                this.setState({ loginFailed: true, loginInProgress: false });
                console.error('Login to admin console failed with message: ' + error.message);
            });
    };

    ssoHandler = () => {
        document.location.href = this.state.ssoServerPath;
    };

    keyDownHandler = (event) => {
        const enterKeyCode = 13;
        if (event.keyCode === enterKeyCode) {
            this.state.loginMode === 'changePassword' ? this.changePasswordHandler() : this.loginHandler();
        }
    };

    onCloudLoginSuccess = () => {
        window.location = this.state.redirectUrl;
    };

    onCloudLoginFailure = () => {
        this.setState({ loginMode: 'cloudResourceLogin' });
    };

    onCloudLoginCancel = () => {
        this.setState({ loginMode: 'login', cloudResourceLoginInProgress: false, username: '', password: '' });
    };

    render() {
        if (this.state.loading) {
            return (
                <div id="login">
                    <div className="silverfort-loader">
                        <div className="logo"></div>
                    </div>
                </div>
            );
        }

        return (
            <CookiesProvider>
                <div id="login" className="bg-black h-screen">
                    <Icon icon={Icons.SilverfortLogo} className="fill-sf-white h-10 w-38 pl-8 pt-8" />
                    <div className="container flex flex-col justify-center items-center h-screen mt-[-100px]">
                        <div>
                            <div
                                className={`login-page bg-white ${
                                    this.state.loginMode === 'login' ? 'w-[360px]' : 'w-[420px]'
                                } rounded-lg p-8`}>
                                <div className="logoContainer flex justify-center">
                                    <div className="flex align-center justify-center h-12 w-12">
                                        <img className="companyLogo w-7 h-[33px]" alt="Logo" src="company_logo.png" />
                                    </div>
                                </div>
                                {this.state.loginMode === 'login' && (
                                    <div className="login-container flex flex-col flex-grow justify-center ">
                                        <div className="login-form flex flex-col w-full ">
                                            <div className="Login-header flex flex-col items-center font-sf-poppins gap-2">
                                                <div className="loginPhrase text-18 text-center font-medium">
                                                    Welcome to Silverfort
                                                </div>
                                                <div className="loginPhrase text-12 text-center font-normal">
                                                    The Identity Security Platform
                                                </div>
                                            </div>
                                            <div className="flex flex-col gap-2">
                                                <div className="flex items-center h-12 w-full mt-8">
                                                    {this.state.showDomain &&
                                                        this.state.domainPrefix &&
                                                        this.state.domain && (
                                                            <Badge
                                                                className="m-2"
                                                                text={this.state.domain}
                                                                color="secondary"
                                                                customClassNames={{ background: 'bg-sf-gray-50' }}
                                                                iconButtonProps={{
                                                                    onClick: this.clearDomainHandler,
                                                                    icon: Icons.Cancel,
                                                                    buttonStyle: IconButtonStyles.Secondary
                                                                }}
                                                            />
                                                        )}
                                                    <div className="w-full">
                                                        <TextInput
                                                            placeholder="Username"
                                                            id="username"
                                                            className="w-full"
                                                            onKeyDown={this.keyDownHandler}
                                                            autoFocus={true}
                                                            value={this.state.username}
                                                            onChange={this.usernameChangedHandler}
                                                        />
                                                    </div>
                                                    {this.state.showDomain &&
                                                        !this.state.domainPrefix &&
                                                        this.state.domain && (
                                                            <Badge
                                                                className="m-2"
                                                                text={this.state.domain}
                                                                color="secondary"
                                                                customClassNames={{ background: 'bg-sf-gray-50' }}
                                                                iconButtonProps={{
                                                                    onClick: this.clearDomainHandler,
                                                                    icon: Icons.Cancel,
                                                                    buttonStyle: IconButtonStyles.Secondary
                                                                }}
                                                            />
                                                        )}
                                                </div>

                                                <div className="w-full">
                                                    <TextInput
                                                        placeholder="Password"
                                                        id="password"
                                                        className="w-full"
                                                        isPassword
                                                        onKeyDown={this.keyDownHandler}
                                                        value={this.state.password}
                                                        onChange={(password) => this.setState({ password: password })}
                                                    />
                                                </div>
                                            </div>

                                            <div className="flex flex-col mt-6 pb-1">
                                                <Button
                                                    text="Sign In"
                                                    className="w-full [&&]:justify-center"
                                                    onClick={() => this.loginHandler()}
                                                    disabled={this.state.loginInProgress}
                                                    buttonSize={ButtonSizes.Large}
                                                />

                                                {this.state.ssoEnabled && (
                                                    <>
                                                        <Button
                                                            text={this.state.ssoText}
                                                            className="w-full [&&]:justify-center mt-3"
                                                            onClick={this.ssoHandler}
                                                            buttonSize={ButtonSizes.Large}
                                                            buttonStyle={ButtonStyles.Tertiary}
                                                        />
                                                    </>
                                                )}
                                            </div>
                                            {this.state.loginFailed && (
                                                <div id="error" className="text-[12px] text-red-600 text-center">
                                                    Invalid credentials
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                                {this.state.loginMode === 'changePassword' && (
                                    <div className="form flex flex-col h-full mt-4">
                                        <div className="login-container flex flex-col flex-grow justify-center">
                                            <div className="login-form flex flex-col space-y-4">
                                                <div className="loginPhrase text-18 text-center font-medium">
                                                    Change Password
                                                </div>
                                                <div className="flex flex-col space-y-3">
                                                    <TextInput
                                                        placeholder={this.state.username || 'Username'}
                                                        id="username"
                                                        className="w-full"
                                                        onKeyDown={this.keyDownHandler}
                                                        autoFocus={true}
                                                        value={this.state.username}
                                                        disabled
                                                    />
                                                    <TextInput
                                                        placeholder="Old password"
                                                        id="old-password"
                                                        className="w-full"
                                                        onKeyDown={this.keyDownHandler}
                                                        value={this.state.oldPassword}
                                                        onChange={(value) => this.setState({ oldPassword: value })}
                                                        isPassword
                                                    />
                                                    <TextInput
                                                        placeholder="New password"
                                                        id="new-password"
                                                        className="w-full"
                                                        onKeyDown={this.keyDownHandler}
                                                        value={this.state.newPassword}
                                                        onChange={(value) => this.setState({ newPassword: value })}
                                                        isPassword
                                                    />
                                                    <TextInput
                                                        placeholder="Confirm password"
                                                        id="confirm-password"
                                                        className="w-full"
                                                        onKeyDown={this.keyDownHandler}
                                                        value={this.state.confirmPassword}
                                                        onChange={(value) => this.setState({ confirmPassword: value })}
                                                        isPassword
                                                    />
                                                </div>
                                                <div className="mt-auto w-full">
                                                    <Button
                                                        disabled={
                                                            !this.state.oldPassword ||
                                                            !this.state.newPassword ||
                                                            !this.state.confirmPassword ||
                                                            this.state.loginInProgress
                                                        }
                                                        onClick={() => this.changePasswordHandler()}
                                                        text="Submit"
                                                        className="w-full [&&]:justify-center"
                                                        size={ButtonSizes.Large}
                                                    />
                                                </div>
                                                {this.state.loginFailed && (
                                                    <div
                                                        id="auth-error"
                                                        className="text-[12px] text-red-600 text-center mt-2">
                                                        Invalid credentials
                                                    </div>
                                                )}
                                                {this.state.changePasswordFailedMsg && (
                                                    <div
                                                        id="password-error"
                                                        className="text-[12px] text-red-600 text-center mt-2">
                                                        {this.state.changePasswordFailedMsg}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {this.state.cloudResourceLoginInProgress && (
                                    <CloudResourcesLogin
                                        onCloudLoginSuccess={this.onCloudLoginSuccess}
                                        onCloudLoginFailure={this.onCloudLoginFailure}
                                        onCloudLoginCancel={this.onCloudLoginCancel}
                                        hidden={this.state.loginMode !== 'cloudResourceLogin'}
                                    />
                                )}
                            </div>
                            {this.state.cloudResourceLoginInProgress && (
                                <div className="flex justify-center text-white text-13 font-sf mt-5">
                                    Authenticating your session…
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </CookiesProvider>
        );
    }
}

export default withRouter(withCookies(Login));
